export const GLOBAL_EXPERIMENT_KEY = 'experiment-a';
export const SM_EXPERIMENT_KEY = 'success-modal-abc-handshake-vs-extra-bid';
export const PD_AVATARS_EXPERIMENT_KEY = 'personal-details-step-ab-with-avatars-vs-without';

// Reserved for future use of experiments
export const EXPERIMENT_VARIANTS = {
  [GLOBAL_EXPERIMENT_KEY]: {
    EXPERIMENT_VARIANT_A: 'control',
    EXPERIMENT_VARIANT_B: 'variant_b',
    EXPERIMENT_VARIANT_C: 'variant_c'
  },
  [SM_EXPERIMENT_KEY]: {
    EXPERIMENT_VARIANT_A: 'control',
    EXPERIMENT_VARIANT_B: 'priority_to_handshake',
    EXPERIMENT_VARIANT_C: 'priority_to_extra_bid'
  },
  [PD_AVATARS_EXPERIMENT_KEY]: {
    EXPERIMENT_VARIANT_A: 'control',
    EXPERIMENT_VARIANT_B: 'pro_avatars'
  }
};
